<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="layout" [@slideSidebar]="sidebarIsOpened" [@routerTransition]="getState(outlet)" [ngClass]="{'layout--web': environment.webBuild}">
	<router-outlet #outlet="outlet"></router-outlet>
	<div class="overlay" [@handleOverlay]="sidebarIsOpened"></div>
</div>
<app-footer *ngIf="environment.webBuild"></app-footer>


// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/components/portal/portal.component.html